import React from 'react';

// Internal modules
import type { IconProps } from './types';

export const TrophyNewSpot = ({
  bgColor,
}: IconProps = {}): React.ReactElement => {
  return (
    <svg
      fill="none"
      height="48"
      viewBox="0 0 48 48"
      width="48"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="24" cy="24" fill={bgColor || '#F7F5F0'} r="24" />
      <path
        clipRule="evenodd"
        d="M32.2673 14.6004C32.2453 14.7579 32.2233 14.9154 32.2014 15.0654C31.967 16.6479 31.4617 19.0929 30.3633 21.4779C31.6302 21.2229 32.6041 20.7804 33.4975 20.1054C34.0761 19.6629 34.6473 19.0179 35.0281 18.2829C35.4089 17.5404 35.5773 16.7754 35.4381 16.0554C35.2697 15.2079 34.8743 14.7354 34.2811 14.5029M32.2656 14.6011C32.4487 14.5036 32.7123 14.4136 33.0199 14.3686C33.4446 14.3161 33.8913 14.3536 34.2795 14.5036M32.8302 12.8607C33.4527 12.7782 34.163 12.8232 34.8221 13.0857C35.9645 13.5357 36.6528 14.4882 36.9018 15.7632C37.1288 16.9107 36.8432 18.0432 36.3526 18.9882C35.862 19.9407 35.137 20.7582 34.39 21.3282C32.9254 22.4382 31.2924 23.0007 29.0955 23.1957L27.6602 23.3232L28.3851 22.0557C29.8278 19.5207 30.4576 16.6407 30.7212 14.8407C30.7578 14.5932 30.7944 14.3232 30.8237 14.0532L30.8676 13.6782L31.1899 13.4907C31.1972 13.4832 31.1972 13.4757 31.2045 13.4757C31.6439 13.1532 32.2297 12.9432 32.8302 12.8607Z"
        fill="#FFC43A"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M14.6968 14.6004C14.7115 14.7579 14.7408 14.9154 14.7628 15.0654C14.9898 16.6479 15.4951 19.0929 16.5935 21.4779C15.3339 21.2229 14.3527 20.7804 13.4666 20.1054C12.8881 19.6629 12.3169 19.0179 11.9287 18.2829C11.5479 17.5404 11.3868 16.7754 11.526 16.0554C11.6871 15.2079 12.0898 14.7355 12.6757 14.5029M14.6969 14.6011C14.5065 14.5036 14.2429 14.4136 13.9353 14.3686C13.5106 14.3161 13.0639 14.3536 12.6758 14.5036M14.1345 12.8607C13.5047 12.7782 12.8017 12.8232 12.1426 13.0857H12.1353C10.9929 13.5357 10.3045 14.4882 10.0555 15.7632C9.83585 16.9107 10.1214 18.0432 10.6121 18.9882C11.1027 19.9407 11.8204 20.7582 12.5747 21.3282C14.0393 22.4382 15.6723 23.0007 17.8619 23.1957L19.3045 23.3232L18.5795 22.0557C17.1296 19.5207 16.5071 16.6407 16.2435 14.8407C16.2069 14.5932 16.1703 14.3232 16.1337 14.0532L16.0897 13.6782L15.7748 13.4907C15.7675 13.4832 15.7602 13.4757 15.7529 13.4757C15.3208 13.1532 14.7276 12.9432 14.1345 12.8607Z"
        fill="#FFC43A"
        fillRule="evenodd"
      />
      <path
        d="M23.1707 33.1336C24.855 33.1336 26.3489 33.1786 27.689 33.2011C25.7264 30.3961 25.06 26.9386 25.4555 23.1586C25.0381 23.1736 24.1007 23.3086 23.6687 23.3086H23.3831C22.8412 23.3086 21.7866 23.1586 21.2594 23.1211C21.4132 26.6836 20.8639 30.2161 18.8867 33.1786C20.1609 33.1636 21.5743 33.1336 23.1707 33.1336Z"
        fill="#D89700"
      />
      <rect
        fill="#FED13C"
        height="4.77393"
        rx="2.38696"
        width="18.9559"
        x="13.7109"
        y="33.0439"
      />
      <path
        d="M32.1345 10.8135H14.5226C14.054 13.9185 15.211 25.986 23.4567 25.986C28.6781 25.986 33.0133 18.891 32.1345 10.8135Z"
        fill="#FED13C"
      />
      <path
        d="M23.0628 14.2114C23.2239 13.8814 23.6853 13.8814 23.8464 14.2114L24.3077 15.1714C24.5201 15.6064 24.9302 15.9139 25.3989 15.9814L26.4314 16.1389C26.7903 16.1914 26.9367 16.6414 26.6731 16.9039L25.9335 17.6464C25.5893 17.9914 25.4355 18.4789 25.516 18.9589L25.6918 20.0164C25.7504 20.3839 25.3769 20.6614 25.0547 20.4889L24.132 19.9939C23.7073 19.7614 23.202 19.7614 22.7846 19.9939L21.8619 20.4889C21.5396 20.6614 21.1588 20.3839 21.2248 20.0164L21.4005 18.9589C21.4811 18.4789 21.32 17.9914 20.9831 17.6464L20.2361 16.9039C19.9725 16.6414 20.119 16.1914 20.4778 16.1389L21.5104 15.9814C21.979 15.9139 22.3891 15.6064 22.6015 15.1714L23.0628 14.2114Z"
        fill="#121661"
      />
    </svg>
  );
};
